import React from "react";
import SubmenuItems from "../../components/Header/SubmenuItems";
import {HiveIcons} from "../../assets/icons";

const PoliciesSubheader = (props) => {

  const menuItems = [
    {
      pushRight: true,
      title: "Add policy",
      icon: <HiveIcons.AddOutlined />,
      onClick: props.handleCreateNew,
    },
  ];

  return <SubmenuItems items={menuItems} />;
};

export default PoliciesSubheader;
